import jwtDecode from "jwt-decode";
import { decryptData } from "../api/encryption";

export function isValidJWT(token: string): boolean {
  if (!token) return false;
  try {
    const decyptedToken = decryptData(token);
    const decoded: any = jwtDecode(decyptedToken);
    if (!decoded.exp || typeof decoded.exp !== "number") return false;

    return Date.now() < decoded.exp * 1000; // Check if token is still valid
  } catch (error) {
    return false;
  }
}
